import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";

import { get } from "../helpers/HTTP";

async function getAttachmentUrlRequest(
  workspaceId: string,
  attachmentId: string,
): Promise<string> {
  const { attachment } = await get(
    `workspaces/${workspaceId}/attachments/${attachmentId}`,
  );
  return attachment.url;
}
export default function useWorkspaceAttachmentUrl(attachmentId: string) {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { attachmentsKeys } = getQueryKeys(workspaceId);

  const { data: attachmentUrl, isLoading: isLoadingAttachmentUrl } = useQuery({
    queryKey: attachmentsKeys.url(attachmentId),
    queryFn: () => getAttachmentUrlRequest(workspaceId, attachmentId),
    enabled: !!attachmentId,
    staleTime: 360 * 1000,
  });

  return {
    attachmentUrl,
    isLoadingAttachmentUrl,
  };
}
